import type { ColumnDef } from '@tanstack/react-table';
import { TanTable } from '../../components/TanTable';

type Props<T> = {
  name: string;
  title: string;
  data: T[];
  columns: ColumnDef<T>[];
  loading?: boolean;
  error?: string | null;
  onRowClick?: (row: T) => void;
  getRowId?: (row: T) => string;
  serverPage?: boolean;
};

export default function LocationAccuracyTable<T>({ name, title, data, columns, loading, error, onRowClick, getRowId, serverPage = false }: Props<T>) {
  return <div className="min-w-0">
    {serverPage && <p className="text-xs text-muted mb-2">Table sorting and filters apply to the loaded records. Use the page filters and result navigation to query other records.</p>}
    <div className="resize-y overflow-hidden min-h-[200px]" style={{ height: Math.min(600, Math.max(240, 140 + data.length * 32)) }}>
      <TanTable<T>
        fillContainer
        data={data}
        columns={columns}
        cardTitle={title}
        settingsKey={`location-accuracy-${name}`}
        loading={loading}
        errorMessage={error}
        getRowId={getRowId}
        onRowClick={onRowClick ? (row, event) => {
          if (event?.target instanceof Element && event.target.closest('a,button,input,select')) return;
          onRowClick(row);
        } : undefined}
        enableSearch
        enableColumnFilters
        enablePagination={!serverPage}
        enableRowsPerPage={!serverPage}
        defaultPageSize={25}
      />
    </div>
  </div>;
}
